export interface BlogType {
  id: string
  tag: TagType
  title: string
  date: any
  timeToRead: number
  paragraphs: Array<ParagraphType>
}

export type TagType =
  | 'JavaScript'
  | 'Rust'
  | 'Life-hacks'
  | 'Educational'
  | 'Machine Learning'

interface ParagraphType {
  title?: string
  text: Array<string>
  code?: string
  spacing?: boolean
  lang?: string
}

export const BlogColors: any = {
  JavaScript: '#fde876',
  Rust: '#ffd4a0',
  'Life-hacks': '#c0e6ff',
  Educational: '#99ffa0',
  'Machine Learning': '#99ffa0',
}
